import {useState} from 'react'
import {View} from 'react-native'
import {msg, Trans} from '@lingui/macro'
import {useLingui} from '@lingui/react'

import {
  ensurePrivateRooms,
  publishPrivacySettings,
} from '#/lib/private/PrivateAccountService'
import {usePrivatePrivacySettings} from '#/lib/private/privateHooks'
import {useAgent, useSession} from '#/state/session'
import {atoms as a, useTheme} from '#/alf'
import * as Toggle from '#/components/forms/Toggle'
import {Text} from '#/components/Typography'
import * as Toast from '#/view/com/util/Toast'

export function PrivateAccountToggle() {
  const t = useTheme()
  const {_} = useLingui()
  const agent = useAgent()
  const {currentAccount} = useSession()
  const [isSaving, setIsSaving] = useState(false)
  const {data: privacy} = usePrivatePrivacySettings(currentAccount?.did)

  const isPrivate = !!privacy?.isPrivate
  const canToggle = !!currentAccount?.did && !isSaving

  const onToggle = async () => {
    if (!currentAccount?.did || isSaving) return
    setIsSaving(true)
    try {
      if (!isPrivate) {
        await ensurePrivateRooms(agent, currentAccount.did)
        await publishPrivacySettings(agent, true)
      } else {
        await publishPrivacySettings(agent, false)
      }
    } catch (err: any) {
      Toast.show(_(msg`There was an issue! ${err?.toString?.() || err}`), 'xmark')
    } finally {
      setIsSaving(false)
    }
  }

  return (
    <View style={[a.flex_1, a.gap_sm]}>
      <Toggle.Item
        name="private_account"
        disabled={!canToggle}
        value={isPrivate}
        onChange={onToggle}
        label={_(msg`Private account`)}
        style={[a.w_full]}>
        <Toggle.LabelText style={[a.flex_1]}>
          <Trans>Private account</Trans>
        </Toggle.LabelText>
        <Toggle.Platform />
      </Toggle.Item>
      <Text style={[a.leading_snug, t.atoms.text_contrast_high]}>
        <Trans>
          When enabled, only approved followers can see your posts and stories.
        </Trans>
      </Text>
    </View>
  )
}
